import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const FilterCount = ({ count, size = 'small' }: { count: number; size?: 'small' | 'default' }) => {
  if (!count) {
    return null;
  }

  // small = 16px, default = 28px
  const styles =
    size === 'small'
      ? {
          lineHeight: 1,
          minWidth: 15,
          height: 16,
          fontSize: 12,
          marginLeft: theme.spacing(1),
          padding: theme.spacing(0, 0.5),
        }
      : { minWidth: '', height: 28 };

  return (
    <Text
      size='small'
      css={{
        color: theme.colors.primary70,
        padding: theme.spacing(0.25, 0.5),
        borderRadius: theme.borderRadius.small,
        backgroundColor: theme.colors.primary10,
        margin: 'auto',
        ...styles,
      }}
    >
      {count > 99 ? '99+' : count}
    </Text>
  );
};

export const FilterCheckIcon = ({ hasFilter }: { hasFilter: boolean }) => {
  if (!hasFilter) {
    return null;
  }
  return (
    <Icon
      name='check-small'
      css={{
        color: theme.colors.primary70,
        padding: theme.spacing(0.25, 0.5),
        borderRadius: theme.borderRadius.small,
        backgroundColor: theme.colors.primary10,
        margin: 'auto',
        marginLeft: theme.spacing(1),
        height: 16,
      }}
    />
  );
};
